import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  // dev2 → the global site nav now lives in the top Search mega-menu, so the
  // legacy hardcoded nav blocks (Search / Visualise / Information) are hidden.
  // Projected content (e.g. result filters via [second]) is kept.
  public isDev2: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
